import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByCountryQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByCountryQueryType,
  AnalyticsSalesByCountryQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByCountryQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByCountryQueryType,
    AnalyticsSalesByCountryQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByCountryQueryType,
    AnalyticsSalesByCountryQueryVariablesType
  >(AnalyticsSalesByCountryQuery, options);
};
